var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"click":_vm._closeAll}},[(_vm.status === 200 && _vm.channelInfo.id)?[_c('mobile')]:(_vm.status === 404)?[_c('status404')]:(_vm.status === 408)?[_c('status408')]:[_c('div',{staticClass:"loading"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }